<div class="p-2">
    <!-- Title -->
    <div class="row pb-2">
        <div class="col-9 h5 text-muted p-0">{{ pageTitle }}</div>
        <div class="col-2 p-0">
            <button type="button" class="btn btn-outline-danger btn-sm float-end" *ngIf="pageMode == 'edit'"
                (click)="onDeletePushNotificationCampaignClick(push_notification_campaign_save_confirm_modal)">Delete
                Campaign</button>
        </div>
        <div class="col-1 p-0">
            <button type="button" class="btn btn-secondary btn-sm text-white float-end fw-bold" title="Back"
                (click)="onBackClick()">
                <i-bs class="text-light" name="arrowLeft" width="22" height="22"></i-bs>
            </button>
        </div>
    </div>

    <div class="row bg-light p-2">
        <div class="col-12">

            <div class="row pt-2 pb-2 bg-white">
                <div class="col-12">

                    <div class="row">
                        <!-- Left -->
                        <div class="col-6">

                            <!-- Campaign name ====================================== -->
                            <div class="row mt-2">
                                <div class="col-12">
                                    <span class="text-muted fw-bold">
                                        Campaign Name
                                        <i-bs name="infoCircle" class="text-primary"
                                            tooltip="Add name of the campaign. Max no of characters are 100."
                                            placement="top">
                                        </i-bs>
                                    </span>

                                    <span class="float-end text-muted small lh-lg">{{ campaignName?.length }}/100</span>

                                    <input type="text" class="form-control mt-2" id="campaign_name" maxlength="100"
                                        placeholder="E.g. Black Friday Sale" [(ngModel)]="campaignName">
                                </div>
                            </div>

                            <!-- Campaign date ====================================== -->
                            <div class="row mt-4">
                                <div class="col-12">
                                    <span class="text-muted fw-bold">
                                        Campaign Date
                                        <i-bs name="infoCircle" class="text-primary" tooltip="Select campaign date."
                                            placement="top">
                                        </i-bs>
                                    </span>

                                    <input type="text" class="form-control text-muted mt-2" id="campaign_date"
                                        placeholder="Select push notification campaign date" bsDatepicker
                                        [bsConfig]="calendarConfig" [minDate]="calendarMinDate" [bsValue]="campaignDate"
                                        (bsValueChange)="onCalendarValueChange($event)">
                                </div>
                            </div>

                            <!-- Campaign Topic ====================================== -->
                            <div class="row mt-4">
                                <div class="col-12">
                                    <span class="text-muted fw-bold">
                                        Target Users
                                        <i-bs name="infoCircle" class="text-primary" tooltip="Select campaign target users."
                                            placement="top">
                                        </i-bs>
                                    </span>

                                    <span class="float-end lh-lg">
                                        <div class="spinner-grow spinner-grow-sm text-info" role="status"
                                            *ngIf="pushNotificationTopicsLoading === true"></div>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-12">
                                    <select class="form-select text-muted" [(ngModel)]="selectedPushNotificationTopic"
                                        (change)="onPushNotificationTopicChange($event)"
                                        [disabled]="pushNotificationTopicsLoading === true">
                                        <option *ngFor="let topic of pushNotificationTopics" [value]="topic.topic_id">{{
                                            topic.topic_desc }}</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Title ====================================== -->
                            <div class="row mt-4">
                                <div class="col-12">
                                    <span class="text-muted fw-bold">
                                        Title
                                        <i-bs name="infoCircle" class="text-primary"
                                            tooltip="Enter push notification title. Max no of characters are 65."
                                            placement="top">
                                        </i-bs>
                                    </span>

                                    <span class="float-end text-muted small lh-lg">{{ pushNotificationTitle?.length
                                        }}/65</span>

                                    <input type="text" class="form-control mt-2" id="push_notification_title"
                                        maxlength="65" placeholder="E.g. Black Friday Sale"
                                        [(ngModel)]="pushNotificationTitle">
                                </div>
                            </div>

                            <!-- Message ====================================== -->
                            <div class="row mt-4">
                                <div class="col-12">
                                    <span class="text-muted fw-bold">
                                        Message
                                        <i-bs name="infoCircle" class="text-primary"
                                            tooltip="Enter push notification message. Max no of characters are 240."
                                            placement="top">
                                        </i-bs>
                                    </span>

                                    <span class="float-end text-muted small lh-lg">{{ pushNotificationMessage?.length
                                        }}/240</span>

                                    <textarea class="form-control mt-2" id="push_notification_message" maxlength="240"
                                        rows="5" placeholder="Enter push notification message here..."
                                        [(ngModel)]="pushNotificationMessage"></textarea>
                                </div>
                            </div>

                            <!-- Image ====================================== -->
                            <div class="row mt-4">
                                <div class="col-12">
                                    <span class="text-muted fw-bold">
                                        Image <span class="text-muted small fw-lighter lh-lg">(optional)&nbsp;</span>
                                        <i-bs name="infoCircle" class="text-primary"
                                            tooltip="Select optional push notification image." placement="top">
                                        </i-bs>
                                    </span>

                                    <span class="float-end text-muted small lh-lg">Aspect ratio of 2:1(W:300px x H:200px) | Max Size:100 Kb</span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-6">
                                    <ngx-dropzone style="height: 30px; font-size: 11px; padding: 10px;" [multiple]="false" (change)="onImageSelect($event)">
                                        <ngx-dropzone-label>Select png or jpg file</ngx-dropzone-label>
                                    </ngx-dropzone>
                                </div>
                                <div class="col-6">
                                    <span class="float-end lh-lg" *ngIf="pushNotificationImage.base64">
                                        <i-bs class="text-danger cursor-pointer" name="trash3" width="15" height="15" (click)="removeSelectedImage()"></i-bs>
                                    </span>
                                </div>
                            </div>

                        </div>

                        <!-- Right -->
                        <div class="col-6">

                            <!-- Preview ====================================== -->
                            <div class="row mt-2">
                                <div class="col-12">
                                    <span class="text-muted fw-bold">Notification Preview</span>
                                </div>
                            </div>
                            
                            <div class="row mt-4">
                                <div class="col-12 mobile-preview">
                                    <div class="notification-preview p-2">
                                        <!-- Image -->
                                        <div class="title placeholder-wave d-flex align-items-center justify-content-center" *ngIf="!pushNotificationImage.base64 && !pushNotificationImage.s3FilePath && !pushNotificationTitle && !pushNotificationMessage">
                                            <span class="placeholder" style="width: 200px; height: 100px;">&nbsp;</span>
                                        </div>
                                        <img class="img" [src]="pushNotificationImage.base64" *ngIf="pushNotificationImage.base64">
                                        <img class="img" [src]="pushNotificationImage.s3FilePath" *ngIf="pushNotificationImage.s3FilePath && !pushNotificationImage.base64">
                                        
                                        <!-- Title -->
                                        <div class="title placeholder-wave" *ngIf="!pushNotificationImage.base64 && !pushNotificationImage.s3FilePath && !pushNotificationTitle && !pushNotificationMessage">
                                            <span class="placeholder w-75" style="height: 5px;">&nbsp;</span>
                                        </div>
                                        <div class="title" aria-placeholder="Title" *ngIf="pushNotificationTitle">
                                            {{ pushNotificationTitle }}
                                        </div>
                                        
                                        <!-- Message -->
                                        <div class="text placeholder-wave" *ngIf="!pushNotificationImage.base64 && !pushNotificationImage.s3FilePath && !pushNotificationTitle && !pushNotificationMessage">
                                            <span class="placeholder w-100" style="height: 5px;"></span>
                                            <span class="placeholder w-100" style="height: 5px;"></span>
                                        </div>
                                        <div class="text" *ngIf="pushNotificationMessage">{{ pushNotificationMessage }}</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-4">
                                <div class="col-12">
                                    <div class="small text-danger text-center pt-1">This preview provides a general idea of how your message
                                        will appear on a mobile device. Actual message rendering will vary depending on the
                                        device.</div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- Save Button -->
                    <div class="row mt-3 pt-3 mb-0 border-top">
                        <div class="col-6">
                        </div>
                        <div class="col-6 text-end">
                            <button type="button" class="btn btn-secondary text-white fw-bold"
                                title="Save Push Notification Campaign"
                                (click)="onSavePushNotificationCampaignClick(push_notification_campaign_save_confirm_modal)">
                                <i-bs class="text-light" name="cloudArrowUp" width="22" height="22"></i-bs>
                            </button>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>

<!-- Push Notification Campaign Save Confirm Modal -->
<ng-template #push_notification_campaign_save_confirm_modal>
    <div class="modal-header">
        <h6 class="modal-title text-muted float-start" *ngIf="pageMode == 'add'">Create Push Notification Campaign</h6>
        <h6 class="modal-title text-muted float-start"
            *ngIf="pageMode == 'edit' &&  isDeletePushNotificationCampaign == false">Edit Push Notification Campaign
        </h6>
        <h6 class="modal-title text-danger float-start"
            *ngIf="pageMode == 'edit' &&  isDeletePushNotificationCampaign == true">Delete Push Notification Campaign
        </h6>

        <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close"
            (click)="hidePushNotificationCampaignSaveConfirmModal()"></i-bs>
    </div>

    <div class="modal-body">
        <p class="text-muted" *ngIf="pageMode == 'add'">Are you sure you want to create this push notification campaign?
        </p>
        <p class="text-muted" *ngIf="pageMode == 'edit'  &&  isDeletePushNotificationCampaign == false">Are you sure you
            want to edit this push notification campaign?</p>
        <p class="text-muted" *ngIf="pageMode == 'edit'  &&  isDeletePushNotificationCampaign == true">Are you sure you
            want to delete this push notification campaign?</p>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-dark fw-bold" title="Cancel" [disabled]="savingPushNotificationCampaign"
            (click)="hidePushNotificationCampaignSaveConfirmModal()">
            No
        </button>

        <button type="button" class="btn btn-secondary text-white fw-bold" title="Create Push Notification Campaign"
            [disabled]="savingPushNotificationCampaign" (click)="submitPushNotificationCampaign()"
            *ngIf="pageMode == 'add' ||  (pageMode == 'edit' &&  isDeletePushNotificationCampaign == false)">
            Yes
            <div class="spinner-border spinner-border-sm" role="status" *ngIf="savingPushNotificationCampaign"></div>
        </button>

        <button type="button" class="btn btn-danger text-white fw-bold" title="Create Push Notification Campaign"
            [disabled]="savingPushNotificationCampaign" (click)="deletePushNotificationCampaign()"
            *ngIf="pageMode == 'edit' &&  isDeletePushNotificationCampaign == true">
            Yes
            <div class="spinner-border spinner-border-sm" role="status" *ngIf="savingPushNotificationCampaign"></div>
        </button>
    </div>
</ng-template>